<template>
    <Sidebar />
    <Header />
    <div class="page-wrapper">
        <div class="page-content">
            <router-view/>
        </div>
    </div>
    <div class="overlay toggle-icon"></div>
    <a href="javaScript:;" class="back-to-top"><i class='bx bxs-up-arrow-alt'></i></a>
    <Footer />
</template>

<script setup>
import Footer from '@/components/partials/Footer.vue';
import Header from '@/components/partials/Header.vue';
import Sidebar from '@/components/partials/Sidebar.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>